<div>
	<div class="welcome-msg">
		<p class="welcome-text">{{ welcometext }}</p>
		<p class="display-username" *ngIf="user">{{ userName }}</p>
	</div>
</div>
